<template>
  <div class="top-left w50 left margin margin_r_hf margin_l_c">
    <div class="styleCard">
      <questions-charts
        v-if="mainView === 'questions'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      />
      <CampaignsChartsPlacement
          v-if="mainView === 'placement'"
          :main-sector="mainView"
          :main-data="multiSelectChartData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import QuestionsCharts from "../components/block_4/QuestionsCharts.component";
import CampaignsChartsPlacement from "../components/block_2/CampaignsChartsPlacement.component";

export default {
  name: "RightBottomChart.container",
  components: {
    CampaignsChartsPlacement,
    QuestionsCharts
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("clients", ["loading"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading",
      "chartsViewBlocks",
      "multiSelectChartData"
    ])
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      mainView: null,
      blockNumber: 4
    };
  },
  mounted() {},

  watch: {
    chartsViewBlocks: function() {
      this.mainView = this.chartsViewBlocks[this.blockNumber];
    }
  }
};
</script>

<style scoped>
.styleCard {
  height: 270px;
  font-family: Montserrat;
  position: relative;
}
.w50 {
  /*width: calc(50%);*/
  width: calc(44%);
}
.left {
  float: left;
}
</style>
